<template>
  <el-collapse
    v-if="collapse"
    accordion
  >
    <el-collapse-item name="1">
      <template slot="title">
        Instructions
      </template>

      <component v-bind:is="instruction" />
    </el-collapse-item>
  </el-collapse>

  <component
    v-else
    v-bind:is="instruction"
  />
</template>

<script>
import Drupal from './Instruction/Drupal'
import Laravel from './Instruction/Laravel'
import Node from './Instruction/Node'
import Php from './Instruction/Php'
import Python from './Instruction/Python'
import Ruby from './Instruction/Ruby'
import Wordpress from './Instruction/Wordpress'

export default {
  props: {
    bundleId: String,
    collapse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Drupal,
    Laravel,
    Node,
    Php,
    Python,
    Ruby,
    Wordpress
  },
  computed: {
    instruction () {
      return this.bundleId.charAt(0).toUpperCase() + this.bundleId.slice(1)
    }
  }
}
</script>
